import { render, staticRenderFns } from "./ShopTransfer.vue?vue&type=template&id=710caea0&scoped=true&"
import script from "./ShopTransfer.vue?vue&type=script&lang=js&"
export * from "./ShopTransfer.vue?vue&type=script&lang=js&"
import style0 from "./ShopTransfer.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ShopTransfer.vue?vue&type=style&index=1&id=710caea0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710caea0",
  null
  
)

export default component.exports